import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as serviceAssignmentActionTypes from '../serviceAssignmentActionTypes';

/**
 * Search ace partner location geolocation
 */
const searchACEPartnerLocationGeolocation = function* searchACEPartnerLocationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        serviceAssignmentActionTypes.SEARCH_ACE_PARTNER_LOCATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const responseAction = yield take([
        serviceAssignmentActionTypes.SEARCH_ACE_PARTNER_LOCATION_GEOLOCATION_REQUEST_SUCCEEDED,
        serviceAssignmentActionTypes.SEARCH_ACE_PARTNER_LOCATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: serviceAssignmentActionTypes.SET_ACE_PARTNER_LOCATION_CANDIDATES,
            payload: {
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchACEPartnerLocationGeolocation;
